import { render, staticRenderFns } from "./importcustomeradd.vue?vue&type=template&id=52d4d0c6"
import script from "./importcustomeradd.vue?vue&type=script&lang=js"
export * from "./importcustomeradd.vue?vue&type=script&lang=js"
import style0 from "./importcustomeradd.vue?vue&type=style&index=0&id=52d4d0c6&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports